import { observer, inject } from "mobx-react"
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ProductCardLines, { cardData } from './ProductCardLines'
import {
  Container,
  Menu,
  Header,
  Icon
} from 'semantic-ui-react'
import ScrollToTopOnMount from './ScrollToTopOnMount'

class PageCatalog extends Component {

  componentDidMount(){
    document.title = 'Catalog - Fascomp Electronic Hardware'
  }

  handleClickPartGroup = (e, id, urlName) => {
    const { openPartGroupPageByUrlName, openPartGroupPageById } = this.props.shop.view;
    if (id)
      openPartGroupPageById(id);
    else
      openPartGroupPageByUrlName(urlName);
  };

  render() {
    return(
      <div>
        <Container>
          <Header as='h2' dividing textAlign='center'>
            <Icon name='book' />
            <Header.Content>Catalog</Header.Content>
          </Header>
          <ProductCardLines lines={cardData} onClickPartGroup={this.handleClickPartGroup} />
        </Container>
        <ScrollToTopOnMount />
      </div>
    )
  }
}

export default inject("shop")(observer(PageCatalog))